module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Área")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditArea) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditArea
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área do terreno",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_terreno),
      callback: function($$v) {
        _vm.form.fields.area_terreno = $$v
      },
      expression: "form.fields.area_terreno"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área construída",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_construida),
      callback: function($$v) {
        _vm.form.fields.area_construida = $$v
      },
      expression: "form.fields.area_construida"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Área útil",
      "suffix": "m²"
    },
    on: {
      "keydown": _vm.formatArea
    },
    model: {
      value: (_vm.form.fields.area_util),
      callback: function($$v) {
        _vm.form.fields.area_util = $$v
      },
      expression: "form.fields.area_util"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.calcada) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" calçada")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.calcada),
      callback: function($$v) {
        _vm.form.fields.calcada = $$v
      },
      expression: "form.fields.calcada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.muro) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" muro")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.muro),
      callback: function($$v) {
        _vm.form.fields.muro = $$v
      },
      expression: "form.fields.muro"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditArea
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [(this.map.center.lat !== null && this.map.center.lng !== null) ? _c('gmap-map', {
    ref: "map",
    staticClass: "map-container",
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "margin-bottom": "30px"
    },
    attrs: {
      "center": _vm.map.center,
      "zoom": 19,
      "options": {
        clickableIcons: false,
        disableDoubleClickZoom: true,
        streetViewControl: false
      }
    },
    on: {
      "idle": _vm.calculateArea
    }
  }, [(_vm.polygon.paths.length > 0) ? _c('gmap-polygon', {
    ref: "polygon",
    attrs: {
      "options": _vm.polygonOptions,
      "paths": _vm.polygon.paths,
      "editable": _vm.canEditArea
    },
    on: {
      "paths_changed": function($event) {
        _vm.updateEdited($event)
      },
      "dblclick": _vm.handleClickForDelete
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.polygon.edited && _vm.polygon.area > 0) ? _c('v-container', {
    staticClass: "py-0 mt-2 mb-4 text-xs-center",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Cálculo aproximado da área desenhada: "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(_vm._s(Math.round(_vm.polygon.area)) + " m²")])])])], 1) : _vm._e(), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48ad99f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesArea.vue
// module id = 1016
// module chunks = 1